Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.FollowersUniqueUsersTimeseriesView extends Monitoring.Views.Charts.CustomHistogramChart

  events:
    'click .maximize': 'onMaximize'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  url: '/monitoring/api/charts/twitter_potential_impressions_unique_users_histogram'

  initialize: (@options = {}) =>
    followers_settings = {
      class: 'FollowersUniqueUsersTimeseriesView',
      type: 'spline',
      dimension: 'user_followers_count',
      title: I18n.t('monitoring.dashboard.charts.tw_potential_impressions_unique_users'),
      showLegend: false,
      showMarkers: true
    }
    @options.settings = merge_options(@options.settings, followers_settings)
    super

  getSearchQuery: ->
    query = super
    query.set('must_be_public_comments', true)
    query.set('type', 'twitter')
    query

  merge_options = (options_settings, chart_settings) ->
    settings = {}
    for attrname of options_settings
      settings[attrname] = options_settings[attrname]
    for attrname of chart_settings
      settings[attrname] = chart_settings[attrname]
    settings

  formatter: ->
    date = new Date(@point.x)
    options = {
      weekday: "long", year: "numeric", month: "short",
      day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    formatted_date = date.toLocaleTimeString("en-us", options)
    formatted_date = formatted_date.substr(0, formatted_date.length - 10)
    color = @point.series.color
    string = '<div style="font-size: 10px;">' +formatted_date + '<br/><span style="color:' + color + ';">●</span> Followers: <b>' + @point.y.toLocaleString() + ' </b></div>'
    string

  _setDimension: (query, key, value) =>
    query.set('type', 'twitter')
